import { Button, Icon } from 'gu-ui-kit'
import React from 'react'
import PropTypes from 'prop-types'

const ToggleButton = ({ hasChild, network, children, active, toggleActiveNetwork }) =>
  hasChild ? (
    <Button
      onClick={() => toggleActiveNetwork(network)}
      variant={'ghost'}
      link
      style={{ padding: 0 }}
      endIcon={
        <Icon
          name={active ? 'arrow-up' : 'arrow-down'}
          color={'Interface-Eighth'}
        />
      }
    >
      {children}
    </Button>
  ) : (
    children
  )
export default ToggleButton

ToggleButton.propTypes = {
  hasChild: PropTypes.bool,
  network: PropTypes.string,
  children: PropTypes.element,
  active: PropTypes.bool,
  toggleActiveNetwork: PropTypes.func,
}
